import { fKeyTabInput } from "../../../Utility/Utilitys";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpInputField,
} from "../../../Component/Common/ToolBox/ToolBox";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import Grid from "@mui/material/Grid";
import {
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function WmsContent({
  sEnterKeyObj,
  xContent_Focus,
  xContent_Blur,
  fCardId,
  fCardIdEnter,
  xBufferObj,
  sUnit,

  fUnit,
  fQty,
  fQty_Enter,
  fItemName,

  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,

  //bin
  xfGC_Toggle_Head_BinName_Name,
  xGC_Toggle_Head_BinName_Toggle = false,
  xGC_Toggle_Head_BinName_onKeyUp,
  xGC_Toggle_Head_BinName_SearchDropdownObj,
  xGC_Toggle_Head_BinName_Dropdown_onChange,
  xGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load,
  xGC_Toggle_Head_BinName_GridColumns,
  xGC_Toggle_Head_BinName_GridData,
  xfGC_Toggle_Head_BinName_OnRowClick,
  xfGC_Toggle_Head_BinName_OnCellKeyDown,
  xGC_Toggle_Head_BinName_DropDown_Arr,
  //bin end
}) {
  return (
    <form
      className="Wms-inbound-grn-content mt-4"
      id="WmsStockAdjustmentContent"
    >
      <Grid
        container
        spacing={{ xs: 0.9, sm: 2, md: 0.9 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
      
        <Grid item xs={12} sm={4} md={1.5} className="lastkeyDetect">
          <GCToggleSearchV1
            xLabelText="Card ID"
            xtabIndex={"102"}
            xName={"B_CardId"}
            xType={"number"}
            xValue={xBufferObj?.B_CardId}
            xReadOnly={false}
            xOnChange={fCardId}
            xOnKeyUp={fCardIdEnter}
            xonClickbtn={fCardIdEnter}
          />
        </Grid>

        <Grid item xs={12} sm={2} md={1.5} className="lastkeyDetect">
          {/* <CmpTypographyField xcomponent={"div"} xText={"Item Code"} /> */}
          <CmpTextFieldV1
            xLabelText="Item Code"
            xValue={xBufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}

            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={xToggle ? 8 : 4}
          // sm={"auto"}
          // md={"auto"}
          // lg={"auto"}
          className="lastkeyDetect"
        >
          <GCToggleSearchV1
            xLabelText="Item Name"
            xtabIndex={"102"}
            xName={"B_ItmName"}
            xType={"text"}
            xValue={xBufferObj?.B_ItmName}
            xReadOnly={true}
            xOnChange={fItemName}
            xOnKeyUp={xonClickbtn}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xonClickbtn}
            xrows={xrows}
            xcolumns={xcolumns} //head
            xRowCellClick={xRowCellClick}
            xRowClick={xRowClick}
            xToggle={xToggle}
            xData={xData}
            xOnChangeDropdownInput={xOnChangeDropdownInput}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
          />
        </Grid>

        <Grid item xs={4} sm={2} md={1.4}>
          <CmpTextFieldV1
            xLabelText="Bincode"
            xValue={xBufferObj.B_BinCode}
            xType={"text"} // text/number/password
            xName={"B_BinCode"}
            xReadOnly={true}
            xOnChange={""}
          />
        </Grid>
        <Grid item xs={8} sm={4} md={2.5}>
          <GCToggleSearchV1
            xLabelText="Bin Name"
            xName={"GC_Toggle_Head_BinName_Name"}
            xType={"text"}
            xValue={xBufferObj.B_BinName}
            xReadOnly={false}
            xOnChange={xfGC_Toggle_Head_BinName_Name} //GCToggleSearch onchange main input
            xOnKeyUp={xGC_Toggle_Head_BinName_onKeyUp} //GCToggleSearch xOnKeyUp main input
            xMediaQuery={false}
            xonClickbtn={xGC_Toggle_Head_BinName_onKeyUp} // GCToggleSearch onclick icon open div on main screen
            xrows={xGC_Toggle_Head_BinName_GridData} //GCToggleSearch-grid
            xcolumns={xGC_Toggle_Head_BinName_GridColumns} //GCToggleSearch-grid
            xRowCellClick={xfGC_Toggle_Head_BinName_OnCellKeyDown}
            xRowClick={xfGC_Toggle_Head_BinName_OnRowClick}
            xToggle={xGC_Toggle_Head_BinName_Toggle} //GCToggleSearch- true/false
            xData={xGC_Toggle_Head_BinName_DropDown_Arr} //GCToggleSearch-select
            xOnChangeDropdownInput={xGC_Toggle_Head_BinName_Dropdown_onChange} //GCToggleSearch -input
            xDropdownObj={xGC_Toggle_Head_BinName_SearchDropdownObj} //GCToggleSearch -obj
            xOnKeyUpDropdownInput={
              xGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load
            } //GCToggleSearch -Enter key and clickc detect
            xtabIndex="107"
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Qty"
            xtabIndex={"103"}
            xValue={xBufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fQty}
            xOnKeyUp={fQty_Enter}
            xonFocus={(e) => {
              xContent_Focus(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={2} className="lastkeyDetect">
          <CmpSelectFieldV1
            xtabIndex={"104"}
            xLabelText="Unit"
            xValue={xBufferObj.B_Unit}
            xOnChange={fUnit}
            xName={"B_Unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xDisable={false}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Packing"
            xtabIndex={"105"}
            xValue={xBufferObj.B_Packing}
            xType={"text"} // text/number/password
            xName={"B_Packing"}
            xReadOnly={true}
            xOnChange={""}

            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Basety"
            xtabIndex={"105"}
            xValue={xBufferObj.B_BaseQty}
            xType={"text"} // text/number/password
            xName={"B_BaseQty"}
            xReadOnly={true}
            xOnChange={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="BatchNo"
            xtabIndex={"105"}
            xValue={xBufferObj.BatchNo}
            xType={"text"} // text/number/password
            xName={"BatchNo"}
            xReadOnly={true}
            xOnChange={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="GRNQty"
            xtabIndex={"105"}
            xValue={xBufferObj.GRNQty}
            xType={"text"} // text/number/password
            xName={"GRNQty"}
            xReadOnly={true}
            xOnChange={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="PutawayWty"
            xtabIndex={"105"}
            xValue={xBufferObj.PutawayQty}
            xType={"text"} // text/number/password
            xName={"PutawayWty"}
            xReadOnly={true}
            xOnChange={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="BalanceQty"
            xtabIndex={"105"}
            xValue={xBufferObj.BalanceQty}
            xType={"text"} // text/number/password
            xName={"BalanceQty"}
            xReadOnly={true}
            xOnChange={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
      </Grid>
    </form>
  );
}
